import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpParams } from '@angular/common/http';
import { Unity } from '../models/unity';
import { Set } from '../models/set';
import { AuthService } from './auth.service';
import { CostUnityRecord } from '../models/cost-unity-record';
import { GasTravel } from '../models/gas-travel';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnityService {

  constructor(private http:HttpClient, private authServ:AuthService) { }

  async getFilteredUnities(type?:number) : Promise<Unity[]> {
    let isMachinery = (this.authServ.isExactly('machinery') || this.authServ.isExactly('staff'));

    if(type) {
      if(isMachinery) { 
        return (await this.getUnities())
          .filter(value => value.unit_type_id == type && (value.user_id == this.authServ.getActualUser().id || value.user_second_id == this.authServ.getActualUser().id))
      } else {
        return (await this.getUnities())
          .filter(value => value.unit_type_id == type)
      }
    } else {
      if(isMachinery) {
        return (await this.getUnities())
          .filter(value => value.user_id == this.authServ.getActualUser().id || value.user_second_id == this.authServ.getActualUser().id);
      } else {
        return await this.getUnities();
      }
    }
  }

  async getUnities() : Promise<Unity[]> {
    return this.http.get<Unity[]>('/api/unity')
      .toPromise();
  }

  async getSets() : Promise<Set[]> {
    return this.http.get<Set[]>('/api/unity/set')
      .toPromise();
  }

  async postUnity(unity:Unity) : Promise<Unity> {
    return this.http.post<Unity>('/api/unity', unity)
      .toPromise();
  }

  async postAvatar(unity:Unity, formData:FormData) : Promise<Unity> {
    return this.http.post<Unity>('/api/unity/' + unity.id + '/avatar', formData).toPromise();
    
    //return this.http.request(req).toPromise();
  }

  async postSet(set:Set) : Promise<Set> {
    return this.http.post<Set>('/api/unity/set', set)
      .toPromise();
  }

  async getUnity(id:Number) : Promise<Unity> {
    return this.http.get<Unity>('/api/unity/' + id)
      .toPromise();
  }
  
  async putUnity(unity:Unity) : Promise<Unity> {
    return this.http.post<Unity>('/api/unity/' + unity.id + '/edit', unity)
      .toPromise();
  }
  
  async deleteUnity(unity:Unity) : Promise<void> {
    return this.http.get<void>('/api/unity/' + unity.id + '/delete')
      .toPromise();
  }

  postCosts(unity:Unity) : Promise<void> {
    return this.http.post<void>('/api/unity/' + unity.id + '/costs', {
      physical_mechanics_date: unity.physical_mechanics_date ? unity.physical_mechanics_date.toString() : null,
      physical_mechanics_date_2: unity.physical_mechanics_date_2 ? unity.physical_mechanics_date_2.toString() : null,
      physical_mechanics_cost: unity.physical_mechanics_cost,
      insurance_issue_date: unity.insurance_issue_date ? unity.insurance_issue_date.toString() : null,
      insurance_expiration_date: unity.insurance_expiration_date ? unity.insurance_expiration_date.toString() : null,
      insurance_cost: unity.insurance_cost,
      pollutant_date: unity.pollutant_date ? unity.pollutant_date.toString() : null,
      pollutant_date_2: unity.pollutant_date_2 ? unity.pollutant_date_2.toString() : null,
      contaminants_verification_cost: unity.contaminants_verification_cost,
    }).toPromise();
  }

  getCosts(unity:Unity) : Promise<CostUnityRecord[]> {
    return this.http.get<CostUnityRecord[]>('/api/unity/' + unity.id + '/costs').toPromise();
  }

  getFiles(unity:Unity) : Promise<string[]> {
    return this.http.get<string[]>('/api/unity/' + unity.id + '/files').toPromise();
  }

  postFile(unity:Unity, formData:FormData) : Promise<HttpEvent<{}>> {
    const req = new HttpRequest('POST', '/api/unity/' + unity.id + '/files', formData);
    
    return this.http.request(req).toPromise();
  }

  postGas(custom:any, unity:Unity) : Promise<any> {
    return this.http.post<any>("/api/unity/" + unity.id + "/gasticket/emmit", custom).toPromise();
  }

  getProecoReport(year:string, type:string, gasType:string) : Promise<any> {
    let params:{year,type?,gasType?} = {year};
    if (type) {
      params.type = type;
    }
    if (gasType) {
      params.gasType = gasType;
    }
    params.year = year ? year : 2020;

    return this.http.get<any>("/api/reports/base/proeco/all", {params}).toPromise();
  }

  getGasTravel(unity:Unity, date1:Date, date2:Date) : Promise<GasTravel[]> {
    return this.http.get<GasTravel[]>("/api/unity/" + unity.id + "/gasticket", {params: {date1: date1.toString(), date2: date2.toString()}}).toPromise();
  }

  uploadToSap(date) : Promise<any> {
    return this.http.post<any>("/api/unity/upload/sap", {date}).toPromise();
  }

  deleteUnityFiles(unity: Unity, delSeletedFiles: any = []): Observable<any>{
    return this.http.delete<any>('/api/unity/' + unity.id + '/delete/file', {params: {id: JSON.stringify(delSeletedFiles)}});
  }
}
